import React, { useEffect, useRef } from "react";
import efr from '../assets/images/efr.svg';
import rice from '../assets/images/imgs/rice.png'
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
export default function EFR() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const efrSection = useRef()
    const pinnedEfrRef = useRef()

    useEffect(() => {
        document.body.className = '';
        document.body.classList.add('brands');
    }, [])

    window.onscroll = () => {

        if (efrSection.current.getBoundingClientRect().top < 20 && efrSection.current.getBoundingClientRect().top > -(efrSection.current.getBoundingClientRect().height - 280)) {
            pinnedEfrRef.current.classList.add('fixed')
        } else {
            pinnedEfrRef.current.classList.remove('fixed')
        }
    }
    return (
        <section className="relative flex gap-[20px] p-[20px] lg:p-[100px] nc" ref={efrSection}>
            <div className="w-[80px] min-w-[80px] lg:w-[150px] lg:min-w-[150px] relative">
                <div onClick={()=>navigate(-1)} ref={pinnedEfrRef} className="z-[999] top-[120px] bg-white border-[#D0A847] border-[2px] w-[80px] min-w-[80px] h-[80px] lg:w-[150px] lg:min-w-[150px] lg:h-[150px] flex items-center justify-center rounded-[10px] transition-all duration-700 cursor-pointer">
                    <img src={efr} className="w-[50px] min-w-[50px] lg:w-[100px] lg:min-w-[100px]" alt="" />
                </div>
            </div>
            <div className="flex flex-col gap-[20px] px-[0px] lg:px-[100px] nc">
                <h1 className="text-[#D0A847] text-xl lg:text-3xl 2xl:text-6xl underline capitalize underline-offset-[12px] decoration-[2px] nc">{t('egyptian_farms')}</h1>
                <h2 className="capitalize text-md lg:text-xl nc">{t('egyptian_farms_desc')}</h2>
                <img src={rice} className="w-full lg:w-3/4 m-auto" alt="" />
            </div>
        </section>
    )
}